import { type Dispatch, type SetStateAction, useState, useEffect } from 'react'
import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded'
import { useQueryClient } from '@tanstack/react-query'

import { useGetQrStatus } from '@/hooks/use-tuya'

export default function QRCodeStatus({
    setShowGeneration,
}: {
    setShowGeneration?: Dispatch<SetStateAction<boolean>>,
}) {

    const queryClient = useQueryClient()
    
    const [keepRefetching, setKeepRefetching] = useState<boolean>(true)
    
    const { status, data, error } = useGetQrStatus(keepRefetching)

    useEffect(() => {
        if (data?.success === true) {
            setKeepRefetching(false)
            queryClient.invalidateQueries({ queryKey: ['connectedTuyaApp'] })
            setShowGeneration(false)
        }
    }, [data])

    if (status === 'pending') {
        return <Box sx={{
            py: 2,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        }}>
            <CircularProgress />
        </Box>
    }

    if (error) {
        return (
            <Box>
                <ErrorOutlineRoundedIcon />
                <Box>{error.message}</Box>
            </Box>
        )
    }

    return (
        <Box sx={{
            py: 2,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        }}>
            <CircularProgress />
        </Box>
    )
}
